const {
  apiRequest,
} = require('../ws');
const {
  uploadDocument: _uploadDocument,
} = require('../upload');

/*
export function apiDocStatuses() {
  return apiRequest('/v1/doc/statuses');
}
*/
export function apiDocSubmit(params) {
  return apiRequest('/v1/console/doc/submit', params);
}
export function apiDocUpload(params) {
  return _uploadDocument({
    ...params,
    uploadUrl: params.uploadUrl || '/v1/doc/upload',
  });
}
export function apiDocRemove(params) {
  return apiRequest('/v1/kyc/doc/remove', params);
}
